var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-scoped evaluation-society-scoped container"
  }, [(_vm.baseInfo) ? _c('div', {
    staticClass: "resume-doc-wpr box-shadow-small border-radius"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.resume.name,
      "gender": _vm.baseInfo.resume.gender == 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.position.name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.position.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.resume.mobilePhone))])], 1), _vm._v(" "), (_vm.canSync) ? _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("同步供应商：" + _vm._s(_vm.evaInfo.syncInfo.isSync ? '已同步' : '未同步'))]), _vm._v(" "), (_vm.evaInfo.syncInfo.isSync) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("同步供应商时间：" + _vm._s(_vm.evaInfo.syncInfo.syncTime))]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), (!_vm.baseInfo.list.length && _vm.evaInfo && !_vm.evaInfo.list.length) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "resume-doc"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [(!_vm.showEdit) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.baseInfo.list.length ? _vm.showEdit : true
    },
    on: {
      "click": function($event) {
        _vm.showEdit = true
      }
    }
  }, [_vm._v("添加评价")]) : _vm._e(), _vm._v(" "), (_vm.showEdit) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showEdit = false && _vm.formKey++
      }
    }
  }, [_vm._v("取消编辑")]) : _vm._e(), _vm._v(" "), (_vm.canSync) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.syncToSupplier
    }
  }, [_vm._v("同步供应商")]) : _vm._e()], 1), _vm._v(" "), (_vm.showEdit) ? _c('div', {
    key: _vm.formKey,
    staticClass: "edit-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "inline": true,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "面试阶段"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择面试阶段"
    },
    on: {
      "change": _vm.changePhase
    },
    model: {
      value: (_vm.interviewInfo.interviewArrangeId),
      callback: function($$v) {
        _vm.$set(_vm.interviewInfo, "interviewArrangeId", $$v)
      },
      expression: "interviewInfo.interviewArrangeId"
    }
  }, _vm._l((_vm.baseInfo.list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.turnName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试官"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择面试官"
    },
    model: {
      value: (_vm.interviewInfo.evaluator),
      callback: function($$v) {
        _vm.$set(_vm.interviewInfo, "evaluator", $$v)
      },
      expression: "interviewInfo.evaluator"
    }
  }, _vm._l((_vm.interviews), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.interviewInfo.evaluator) ? _c('society-form', {
    attrs: {
      "turn": _vm.turn,
      "isSimple": _vm.evaInfo.isSimple,
      "isFull": true,
      "extInfo": _vm.interviewInfo,
      "scoreType": _vm.baseInfo.position.scoreType,
      "advise": _vm.baseInfo.position.advise,
      "recruitType": _vm.evaInfo.recruitType
    },
    on: {
      "refresh": _vm.addSuccess,
      "cancel": _vm.cancelEdit
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.evaInfo && _vm.evaInfo.list.length) ? _c('div', {
    staticClass: "history-form"
  }, _vm._l((_vm.evaInfo.list), function(evaluate, index) {
    return (evaluate.evaList.length) ? _c('el-table', {
      key: index,
      staticClass: "evaluation-item",
      attrs: {
        "row-class-name": "evaluate-row",
        "show-header": false,
        "data": [{}]
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "200",
        "class-name": "name-td"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(evaluate.turnName) + "评价结果")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return _vm._l((evaluate.evaList), function(item, idx) {
            return _c('div', {
              key: idx,
              staticClass: "evaluate-row"
            }, [_c('div', {
              staticClass: "isView"
            }, [_c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试结果：")]), _vm._v(_vm._s(_vm.getSelectMapText('WB_USER_VIEWPOINT', item.userViewpoint)) + "\n                                        ")])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试官：")]), _vm._v(_vm._s(item.interviewer.name) + "\n                                        ")]), _vm._v(" "), _c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("时间：")]), _vm._v(_vm._s(item.evaluateTime) + "\n                                        ")])], 1), _vm._v(" "), (!_vm.baseInfo.position.scoreType || !_vm.typeList.includes(_vm.baseInfo.position.scoreType)) ? _c('div', [_c('span', [(!_vm.evaInfo.isSimple && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15"
            }, [(_vm.evaInfo.recruitType === 'social') ? _c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("建议定级：")]), _vm._v(_vm._s(item.grade))]) : _vm._e(), _vm._v(" "), _c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评分标准：")]), _vm._v(_vm._s(item.score))])], 1) : (_vm.evaInfo.isSimple) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评价等级：")]), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.grade))])])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.evaInfo.isSimple && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试记录：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.interviewRecord))])])], 1) : _vm._e(), _vm._v(" "), (!_vm.evaInfo.isSimple && _vm.evaInfo.recruitType === 'social' && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("当前薪酬：")]), _vm._v(" "), (item.monthBaseSalary) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v("月薪" + _vm._s(item.monthBaseSalary) + "*" + _vm._s(item.monthCount) + "个月，" + _vm._s(item.otherWelfare))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.evaInfo.isSimple && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v(_vm._s(['18', '19', '20'].includes(_vm.baseInfo.position.scoreType) ? '期望薪资：' : '期望描述：'))]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1), _vm._v(" "), (item.hireAdvice) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v(_vm._s(['18', '19', '20'].includes(_vm.baseInfo.position.scoreType) ? '岗位建议方向：' : '录用方向建议：'))]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.hireAdvice))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['4', '5', '6', '7', '8', '9', '10', '17', '21', '22', '23', '24'].includes(_vm.baseInfo.position.scoreType)) ? _c('div', [(_vm.baseInfo.position.scoreType !== '6') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评分标准：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.score))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("建议薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.adviceSalary))])])], 1), _vm._v(" "), (_vm.baseInfo.position.scoreType === '6' || _vm.baseInfo.position.scoreType === '7' || _vm.baseInfo.position.scoreType === '8') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("当前薪资：")]), _vm._v(" "), (item.monthBaseSalary) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v("月薪" + _vm._s(item.monthBaseSalary) + "*" + _vm._s(item.monthCount) + "个月，" + _vm._s(item.otherWelfare))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("期望薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试记录：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.interviewRecord))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1), _vm._v(" "), (item.hireAdvice) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v(_vm._s(['17', '21', '22', '23', '24'].includes(_vm.baseInfo.position.scoreType) ? '岗位建议方向：' : '录用方向建议：'))]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.hireAdvice))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['11', '12', '13'].includes(_vm.baseInfo.position.scoreType)) ? _c('div', [(['12', '13'].includes(_vm.baseInfo.position.scoreType) && evaluate.turn === '0') ? _c('div', _vm._l((_vm.scoreMapList), function(scoreMap, index) {
              return _c('el-row', {
                key: scoreMap.name,
                class: [
                  [0, 6].includes(index) ? 'mt-15' : 'mt-5'
                ]
              }, [_c('el-col', [_c('span', {
                staticClass: "txt-label"
              }, [_vm._v(_vm._s([6, 7, 8].includes(index) ? '个人素质' : '综合能力') + "-" + _vm._s(scoreMap.name) + "：")]), _vm._v(" "), (item[scoreMap.prop]) ? _c('pre', {
                staticClass: "multi-row-content"
              }, [_vm._v(_vm._s(item[scoreMap.prop]))]) : _vm._e()])], 1)
            }), 1) : _vm._e(), _vm._v(" "), (_vm.baseInfo.position.scoreType === '12' && evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("专业能力：")]), _vm._v(" "), (item.professionalProjMgr) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.professionalProjMgr))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.baseInfo.position.scoreType === '13' && evaluate.turn === '0') ? _c('div', _vm._l((_vm.skillMapList), function(skillMap, index) {
              return _c('el-row', {
                key: skillMap.name,
                class: [index ? 'mt-5' : 'mt-15']
              }, [_c('el-col', [_c('span', {
                staticClass: "txt-label"
              }, [_vm._v("专业能力-" + _vm._s(skillMap.name) + "：")]), _vm._v(" "), (item[skillMap.prop]) ? _c('pre', {
                staticClass: "multi-row-content"
              }, [_vm._v(_vm._s(item[skillMap.prop]))]) : _vm._e()])], 1)
            }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.baseInfo.position.scoreType) && evaluate.turn === '0') ? _c('div', _vm._l((_vm.otherMapList), function(otherMap, index) {
              return _c('el-row', {
                key: otherMap.name,
                class: [index ? 'mt-5' : 'mt-15']
              }, [_c('el-col', [_c('span', {
                staticClass: "txt-label"
              }, [_vm._v("其他-" + _vm._s(otherMap.name) + "：")]), _vm._v(" "), (item[otherMap.prop]) ? _c('pre', {
                staticClass: "multi-row-content",
                staticStyle: {
                  "width": "690px"
                }
              }, [_vm._v(_vm._s(item[otherMap.prop]))]) : _vm._e()])], 1)
            }), 1) : _vm._e(), _vm._v(" "), (evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("当前薪资：")]), _vm._v(" "), (item.monthBaseSalary) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v("月薪" + _vm._s(item.monthBaseSalary) + "*" + _vm._s(item.monthCount) + "个月，" + _vm._s(item.otherWelfare))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("期望薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.baseInfo.position.scoreType) && evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("最快到岗时间：")]), _vm._v(" "), (item.lastEntryTime) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.lastEntryTime))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1)], 1) : _vm._e(), _vm._v(" "), (['14', '15', '16'].includes(_vm.baseInfo.position.scoreType)) ? _c('div', [_c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评分标准：")]), _vm._v(_vm._s(item.score))])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("期望薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试记录：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.interviewRecord))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1), _vm._v(" "), (item.hireAdvice) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("录用方向建议：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.hireAdvice))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
              staticStyle: {
                "position": "absolute",
                "right": "0px",
                "bottom": "10px"
              },
              attrs: {
                "size": "small"
              },
              on: {
                "click": function($event) {
                  return _vm.showEditPopup(item, evaluate)
                }
              }
            }, [_vm._v("编辑")])], 1)])
          })
        }
      }], null, true)
    })], 1) : _vm._e()
  }), 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改评价",
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.dialogInfo && _vm.baseInfo && _vm.evaInfo) ? _c('div', {
    staticClass: "isEdit"
  }, [_c('society-form', {
    ref: "updateForm",
    attrs: {
      "turn": _vm.dialogInfo.turn,
      "isSimple": _vm.evaInfo.isSimple,
      "isEdit": true,
      "isFull": true,
      "extInfo": _vm.dialogInfo.extInfo,
      "scoreType": _vm.baseInfo.position.scoreType,
      "advise": _vm.baseInfo.position.advise,
      "recruitType": _vm.evaInfo.recruitType
    },
    on: {
      "refresh": _vm.updateSuccess,
      "cancel": function($event) {
        _vm.dialogVisible = false
      }
    }
  })], 1) : _vm._e()])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "100px 0",
      "text-align": "center",
      "color": "#ccc"
    }
  }, [_c('i', {
    staticClass: "el-icon-information"
  }), _vm._v("该应聘者还没有面试安排，不可添加面试评价")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e2168a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society.vue
// module id = null
// module chunks = 